import {Work} from '../../../../shared/types/work';
import {SearchSuggestion} from '../components/search-suggestions/search-suggestions';

import {checkIsBeforeYear1945} from './check-before-year-1945';

/**
 * Escapes special characters in user input for regex
 */
const escapeRegExp = (userInput: string): string =>
  userInput.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');

/**
 * Splits user input at commas, to allow search over multiple attributes
 */
const prepareRegExp = (userInput: string): string =>
  userInput
    .split(',')
    .map(userInputBlock => `(${escapeRegExp(userInputBlock)})`)
    .join('|');

/**
 * Runs search over work of arts
 * Returns the search results
 */
// eslint-disable-next-line complexity
const getWorkSuggestions = (
  works: Array<Work> | undefined,
  userInput: string,
  maxNumberOfSuggestions: number
): Array<SearchSuggestion> => {
  if (!works) {
    return [];
  }

  const suggestions: Array<SearchSuggestion> = [];
  const regex = new RegExp(prepareRegExp(userInput), 'gim');

  for (const work of works) {
    if (suggestions.length >= maxNumberOfSuggestions) {
      break;
    }

    const {artist, title, description} = work;

    if (
      artist.match(regex) ||
      title.match(regex) ||
      description.de.match(regex) ||
      description.en?.match(regex)
    ) {
      const {id, street = '', postalCode = '', city, year} = work;
      const address = `${street}${
        street && (postalCode || city) ? ', ' : ''
      }${postalCode}${postalCode && city ? ' ' : ''}${city}`;
      const isBeforeYear1945 = checkIsBeforeYear1945(year);

      suggestions.push({
        id,
        label: `${artist}, ${title}, ${address}`,
        isWorkOfArt: true,
        ...(isBeforeYear1945 !== null && {isBeforeYear1945})
      });
    }
  }

  return suggestions;
};

export default getWorkSuggestions;
